import React from "react";
import Typewriter from "typewriter-effect";

import img2 from "../../../../assets/images/imgae-1.jpg"

const Banner = () => {
  return (
    <div className="text-white">
      <div className="hero min-h-screen">
        <div className="hero-content flex-col lg:flex-row-reverse">
          <img data-aos="zoom-in-up" src={img2} className="max-w-sm mt-10 mask mask-decagon rounded-lg shadow-2xl" alt="banner" />
          <div>
            <h1 data-aos="flip-up" data-aos-duration="3000" data-aos-delay="0" 
              className="text-5xl font-bold mb-8"
              style={{ paddingTop: "3rem", marginTop: "20px" }}
            >
              Hi , I'm <span className="text-pink-700">Alamin Sarker</span>
            </h1>
            <span
              className="text-3xl"
              style={{
                color: "pink",
                marginLeft: "10px",
                fontWeight: "bold",
              }}
            >
                <Typewriter
      options={{
        strings: [
          "Junior Web Developer",
          "Forntend Developer",
          "Backend Developer",
          "MERN Stack Developer",
          "UI/UX Designer",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
            </span>

            <p  data-aos="slide-right" className="py-6 text-xl lg:max-w-md">
              Self-motivated, creative, and ambitious software developer and
              seeking a challenging career with a good organization that
              provides the opportunity. Interested with to learn new technology and apply themes on projects.
            </p>
            <a data-aos="zoom-in-up" rel="noreferrer" target="_blank" href="https://drive.google.com/file/d/1AP9eB8uNkoxM6FynbjXWE3v1y25h3-G9/view" >
            <button className="btn bg-pink-600 hover:bg-pink-800 outline-none">Download Resume</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
